module.exports = __webpack_public_path__ + "img/cloud-computing.090dc861.svg";